import { render } from "./StudentId.vue?vue&type=template&id=db010b96&scoped=true"
import script from "./StudentId.vue?vue&type=script&lang=js"
export * from "./StudentId.vue?vue&type=script&lang=js"

import "./StudentId.vue?vue&type=style&index=0&id=db010b96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db010b96"]])

export default __exports__